<template>
  <div class="index">
    <main-body></main-body>
    <router-view></router-view>
  </div>
</template>

<script>
import mainBody from './components/mainBody';

export default {
  name: 'index',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {
    // let {
    //   query: { chirld },
    //   path
    // } = this.$route;
    // this.$router.push({
    //   path: `${path}/${chirld}`
    // });
  },
  components: {
    mainBody
  }
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.index {
  .top {
    position: relative;
    img {
      height: 710px;
    }
    .ul {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 98px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .li {
        font-size: 28px;
        cursor: pointer;
        color: #fff;
        font-family: 'PingFang';
        &:hover {
          color: #f15030;
        }
      }
    }
  }
  .modular {
    width: 1920px;
    height: 1455px;
    background: #efeff4;
    overflow: hidden;
    .title {
      display: flex;
      margin-top: 110px;
      padding: 0 354px 0 423px;
      .icon {
        margin-left: 30px;
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        width: 1000px;
        // margin-left: 20px;
        font-size: 28px;
        font-family: 'PingFang';
        font-weight: 600;
        color: #252525;
        margin-left: 30px;
        line-height: 40px;
        span {
          color: #f15030;
        }
      }
    }
    .center {
      margin-top: 100px;
      padding: 0 280px;
      box-sizing: border-box;
      .ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .li {
          display: flex;
          margin-top: 65px;
          .left {
            display: flex;
            align-items: center;
            img {
              width: 90px;
            }
          }
          .right {
            margin-left: 41px;
            font-family: 'PingFang';
            .name {
              font-size: 34px;
              font-weight: bold;
              color: #252525;
            }
            .context {
              width: 470px;
              font-size: 24px;
              font-weight: bold;
              color: #252525;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
  .light {
    width: 1920px;
    height: 587px;
    background: #ffffff;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 90px;
      .icon {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        font-size: 38px;
        font-family: 'PingFang';
        font-weight: 600;
        color: #252525;
        margin-left: 10px;
      }
    }
    .center {
      .ul {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 350px 0 440px;
        flex-wrap: wrap;
        .li {
          font-family: 'PingFang';
          display: flex;
          align-items: center;
          margin-top: 80px;
          .block {
            width: 50px;
            height: 50px;
            background: #f15030;
            text-align: center;
            color: #fff;
            font-size: 34px;
            color: #ffffff;
            line-height: 50px;
          }
          .text {
            font-weight: bold;
            font-size: 28px;
            color: #252525;
            margin-left: 30px;
          }
        }
      }
    }
  }
}
</style>
